import { redirect, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_app/bookings/')({
	beforeLoad: () => {
		throw redirect({ to: '/bookings/dashboard' });
	},
});
